module.exports = __webpack_public_path__ + "static/assets/44b4af679d985df57d1c0c911931937b.svg";